import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'buc-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'Baptist Urgent Care',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 1-615-988-2000,
  email: 'support@baptisturgentcare.net',
  poweredByLogo: false,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/buc/index.js